export interface Question {
  id: number;
  text: string;
  dosha: "vata" | "pitta" | "kapha";
}

export const questions: Question[] = [
  // VATA (1-27)
  { id: 1, text: "Sinto frequentemente ansiedade e preocupações.", dosha: "vata" },
  { id: 2, text: "Minha mente é muito ativa e difícil de acalmar.", dosha: "vata" },
  { id: 3, text: "Tenho dificuldade para dormir ou insônia.", dosha: "vata" },
  { id: 4, text: "Meu humor muda rapidamente.", dosha: "vata" },
  { id: 5, text: "Sinto meus membros frios com frequência.", dosha: "vata" },
  { id: 6, text: "Tenho pele seca que precisa de hidratação constante.", dosha: "vata" },
  { id: 7, text: "Meu apetite é irregular - às vezes como muito, outras vezes nada.", dosha: "vata" },
  { id: 8, text: "Tenho tendência a constipação ou intestino preso.", dosha: "vata" },
  { id: 9, text: "Me sinto facilmente fatigado fisicamente.", dosha: "vata" },
  { id: 10, text: "Tenho dificuldade de concentração e foco.", dosha: "vata" },
  { id: 11, text: "Sinto nervosismo ou tremores quando estou ansioso.", dosha: "vata" },
  { id: 12, text: "Meus cabelos são secos, quebradiços ou frágeis.", dosha: "vata" },
  { id: 13, text: "Prefiro ambientes quentes e evito frio.", dosha: "vata" },
  { id: 14, text: "Tenho dificuldade em tomar decisões.", dosha: "vata" },
  { id: 15, text: "Sinto falta de ar ou respiro rápido quando nervoso.", dosha: "vata" },
  { id: 16, text: "Me movimento rapidamente e mudo de posição frequentemente.", dosha: "vata" },
  { id: 17, text: "Minha memória é boa de curto prazo, mas esqueço coisas rapidamente.", dosha: "vata" },
  { id: 18, text: "Sinto formigamento ou dormência nas extremidades.", dosha: "vata" },
  { id: 19, text: "Tenho ossos proeminentes ou estrutura corporal fina.", dosha: "vata" },
  { id: 20, text: "Sou criativo e tenho muitas ideias, mas pouca execução.", dosha: "vata" },
  { id: 21, text: "Prefiro comidas doces, salgadas ou azedas.", dosha: "vata" },
  { id: 22, text: "Sinto dores nas articulações ou rigidez.", dosha: "vata" },
  { id: 23, text: "Minha fala é rápida e às vezes desconectada.", dosha: "vata" },
  { id: 24, text: "Tenho olhos pequenos ou secos.", dosha: "vata" },
  { id: 25, text: "Sinto meu corpo leve e ágil.", dosha: "vata" },
  { id: 26, text: "Tenho dificuldade em criar rotinas e me manter nelas.", dosha: "vata" },
  { id: 27, text: "Sinto espasmos ou cólicas frequentes.", dosha: "vata" },

  // PITTA (28-54)
  { id: 28, text: "Tenho tendência a sentir raiva ou irritação.", dosha: "pitta" },
  { id: 29, text: "Minha pele é sensível, com tendência a acne ou vermelhidão.", dosha: "pitta" },
  { id: 30, text: "Sinto calor corporal excessivo, especialmente nas palmas.", dosha: "pitta" },
  { id: 31, text: "Tenho apetite forte e preciso comer regularmente.", dosha: "pitta" },
  { id: 32, text: "Sinto azia ou queimação no estômago.", dosha: "pitta" },
  { id: 33, text: "Sou competitivo e gosto de vencer.", dosha: "pitta" },
  { id: 34, text: "Prefiro ambientes frescos e evito calor.", dosha: "pitta" },
  { id: 35, text: "Tenho tendência a diarreia ou evacuação frequente.", dosha: "pitta" },
  { id: 36, text: "Sinto sede frequente e bebo muita água.", dosha: "pitta" },
  { id: 37, text: "Meus olhos são sensíveis à luz.", dosha: "pitta" },
  { id: 38, text: "Sou organizado, detalhista e perfeccionista.", dosha: "pitta" },
  { id: 39, text: "Tenho cabelos finos, oleosos ou com tendência a queda.", dosha: "pitta" },
  { id: 40, text: "Sinto impaciência quando as coisas demoram.", dosha: "pitta" },
  { id: 41, text: "Minha digestão é rápida - sinto fome pouco depois de comer.", dosha: "pitta" },
  { id: 42, text: "Tenho lábios ou língua avermelhados.", dosha: "pitta" },
  { id: 43, text: "Sou assertivo e gosto de liderar.", dosha: "pitta" },
  { id: 44, text: "Sinto dor de cabeça do tipo enxaqueca.", dosha: "pitta" },
  { id: 45, text: "Prefiro comidas frescas, frias e doces.", dosha: "pitta" },
  { id: 46, text: "Tenho corpo musculoso ou de média estrutura.", dosha: "pitta" },
  { id: 47, text: "Sinto frustração quando não consigo o que quero.", dosha: "pitta" },
  { id: 48, text: "Meu suor tem odor forte ou frequente.", dosha: "pitta" },
  { id: 49, text: "Sou bom em argumentar e debater.", dosha: "pitta" },
  { id: 50, text: "Tenho unhas macias ou sensíveis.", dosha: "pitta" },
  { id: 51, text: "Sinto meu corpo quente ao toque.", dosha: "pitta" },
  { id: 52, text: "Tenho dificuldade em lidar com críticas.", dosha: "pitta" },
  { id: 53, text: "Sou determinado e focado em metas.", dosha: "pitta" },
  { id: 54, text: "Sinto queimação ao urinar ou urina amarela.", dosha: "pitta" },

  // KAPHA (55-81)
  { id: 55, text: "Tenho tendência a ganhar peso facilmente.", dosha: "kapha" },
  { id: 56, text: "Sou lento para iniciar atividades ou me mover.", dosha: "kapha" },
  { id: 57, text: "Sinto sonolência durante o dia, especialmente após refeições.", dosha: "kapha" },
  { id: 58, text: "Minha digestão é lenta e pesada.", dosha: "kapha" },
  { id: 59, text: "Tenho memória excelente e lembro de detalhes antigos.", dosha: "kapha" },
  { id: 60, text: "Sinto meu corpo pesado ou com retenção de líquidos.", dosha: "kapha" },
  { id: 61, text: "Prefiro ambientes quentes e secos.", dosha: "kapha" },
  { id: 62, text: "Tenho pele oleosa, espessa ou hidratada.", dosha: "kapha" },
  { id: 63, text: "Sou calmo, paciente e tranquilo.", dosha: "kapha" },
  { id: 64, text: "Minha fala é lenta e deliberada.", dosha: "kapha" },
  { id: 65, text: "Tenho cabelos grossos, ondulados ou oleosos.", dosha: "kapha" },
  { id: 66, text: "Sinto dificuldade em mudar hábitos ou rotinas.", dosha: "kapha" },
  { id: 67, text: "Meu apetite é moderado, mas como mentalmente.", dosha: "kapha" },
  { id: 68, text: "Tenho estrutura corporal larga ou ossos grandes.", dosha: "kapha" },
  { id: 69, text: "Sinto congestionamento nasal ou produção de muco.", dosha: "kapha" },
  { id: 70, text: "Prefiro comidas picantes, quentes ou amargas.", dosha: "kapha" },
  { id: 71, text: "Sou apegado a pessoas e lugares.", dosha: "kapha" },
  { id: 72, text: "Sinto fadiga ou preguiça mesmo após descansar.", dosha: "kapha" },
  { id: 73, text: "Tenho olhos grandes, brilhantes e expressivos.", dosha: "kapha" },
  { id: 74, text: "Sou tolerante e compreensivo com os outros.", dosha: "kapha" },
  { id: 75, text: "Sinto meu corpo forte e resistente.", dosha: "kapha" },
  { id: 76, text: "Tenho dificuldade em acordar cedo pela manhã.", dosha: "kapha" },
  { id: 77, text: "Sinto depressão ou melancolia quando desequilibrado.", dosha: "kapha" },
  { id: 78, text: "Minha pele é pálida ou brilhante.", dosha: "kapha" },
  { id: 79, text: "Sou leal e mantenho amizades por muito tempo.", dosha: "kapha" },
  { id: 80, text: "Sinto meus dentes e gengivas fortes.", dosha: "kapha" },
  { id: 81, text: "Tenho tendência a colecionar coisas ou acumular.", dosha: "kapha" },
];

export const answerOptions = [
  { value: 1, label: "Discordo Totalmente", icon: "ri-emotion-unhappy-line" },
  { value: 2, label: "Discordo", icon: "ri-emotion-normal-line" },
  { value: 3, label: "Às Vezes", icon: "ri-emotion-line" },
  { value: 4, label: "Concordo", icon: "ri-emotion-happy-line" },
  { value: 5, label: "Concordo Totalmente", icon: "ri-emotion-laugh-line" },
];